import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './MaximeHuet.css';

import maximeHuetImage from '../images/Maxime-HUET-Technicien-en-dépannage-informatique-300x182.webp';

const MaximeHuet = () => {
  return (
    <>
      <Helmet>
        <title>Maxence Huret - Technicien en dépannage informatique à Nantes</title>
        <meta name="description" content="Maxence Huret, technicien expert en dépannage informatique à Nantes. Gérant de Mon Dépannage Informatique, spécialiste intervention à domicile, formation personnalisée, maintenance informatique Loire-Atlantique." />
        <meta name="keywords" content="Maxence Huret, technicien informatique, dépannage informatique, Nantes, gérant, Mon Dépannage Informatique, intervention domicile, formation personnalisée, Loire-Atlantique" />
      </Helmet>

      <div className="page-content">
        <div className="container">
          <article className="page-article">
            <div className="entry-content">
              <div className="profile-section">
                <div className="profile-image">
                  <img 
                    src={maximeHuetImage} 
                    alt=" Maxence Huret - Technicien en dépannage informatique"
                    className="profile-photo"
                  />
                </div>
                
                <div className="profile-content">
                  <h1>Maxence Huret</h1>
                  <h2>Technicien Expert en Dépannage Informatique</h2>
                  
                  <div className="profile-details">
                    <h3>Gérant de Mon Dépannage Informatique</h3>
                    
                    <p>
                      <strong>Maxence Huret</strong> est le dirigeant et <Link to="/blog/informaticien-expert-vs-amateur-notre-verdict-2025" className="blog-link"><strong>technicien expert</strong></Link> de <strong>Mon Dépannage Informatique</strong>, entreprise spécialisée dans le dépannage informatique à domicile sur Nantes et l'ensemble de la Loire-Atlantique.
                    </p>
                    
                    <h4>Expertise et Compétences</h4>
                    <ul className="expertise-list">
                      <li>Dépannage informatique à domicile</li>
                      <li>Formation personnalisée (web et bureautique)</li>
                      <li>Installation de matériels et logiciels</li>
                      <li>Conseil en solutions high-tech</li>
                      <li>Maintenance préventive et curative</li>
                      <li>Récupération de données</li>
                      <li>Optimisation des performances</li>
                      <li>Assistance technique à distance</li>
                    </ul>
                    
                    <h4>Zone d'Intervention</h4>
                    <p>
                    Maxence Huret intervient dans toute l'agglomération nantaise et l'ensemble de la Loire-Atlantique (44) pour tous vos besoins en dépannage informatique.
                    </p>
                    
                    <h4>Approche Professionnelle</h4>
                    <p>
                      Passionné d'informatique et <Link to="/blog/informaticien-expert-vs-amateur-notre-verdict-2025" className="blog-link"><strong>professionnel chevronné</strong></Link>, Maxence Huret évolue depuis de nombreuses années dans le secteur informatique. Son expertise technique approfondie lui permet d'intervenir sur une large gamme d'appareils : ordinateurs fixes et portables, tablettes tactiles, et tous types d'équipements numériques.
                    </p>
                    
                    <p>
                      Son approche se caractérise par une tarification transparente avec des forfaits annoncés à l'avance, sans dépassement ni surprise. Une fois la panne résolue, vous réglez uniquement le forfait convenu initialement.
                    </p>
                    
                    <h4>Services Proposés</h4>
                    <ul className="services-list">
                      <li>Intervention à domicile ou sur site professionnel</li>
                      <li>Télémaintenance et assistance à distance</li>
                      <li>Formation personnalisée en informatique et bureautique</li>
                      <li>Installation et configuration d'équipements</li>
                      <li>Récupération de données sur tous supports</li>
                      <li>Optimisation et <Link to="/blog/4-types-maintenance-informatique-comparatif-expert" className="blog-link"><strong>maintenance préventive</strong></Link></li>
                      <li>Conseil en solutions high-tech</li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="contact-cta">
                <h2>Contactez Maxence Huret</h2>
                <p>Technicien expert à votre service</p>
                <p>Intervention rapide dans toute la Loire-Atlantique</p>
                <p>Téléphone : <Link to="/contact" className="phone-link">Contactez-nous</Link></p>
                <Link to="/contact" className="btn btn-primary">Nous contacter</Link>
              </div>
            </div>
          </article>
        </div>
      </div>
    </>
  );
};

export default MaximeHuet;
